import React from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import ButtonBase from '../../../components/Buttons/ButtonBase';
import { ADDITIONAL_INFO } from '../../../routes';

const useStyles = makeStyles({
  colorGrayIcon: {
    color: '#c1c1c1',
    padding: 0,
  },
  TextField: {
    maxWidth: '368px',
    height: 74,
  },
  colorActiveLabel: {
    color: '#484848',
    fontSize: 14,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    margin: 0,
    paddingLeft: 0,
  },
  labelTermino: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#484848',
    outline: 'none',
    textDecoration: 'none',
  },
  labelTerminoDisabled: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#c1c1c1',
  },
  FormControlLabelRoot: {
    width: '100%',
  },
  button: {
    width: 368,
    cursor: 'pointer',
    backgroundColor: '#35b9b6',
    margin: '30px 0 32px',
    '@media(max-width: 560px)': {
      width: 296,
      marginBottom: 24
    }
  },
});

const AppOpinion = (props) => {
  const {
    values: { name, email, phone, commentary, termsAndConditions },
    handleSubmit,
    handleChange,
    touched,
    handleBlur,
    errors,
    isValid,
  } = props;

  const classes = useStyles();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginTop: 32,
        alignItems: 'center',
      }}
    >
      <TextField
        label="Nombre completo*"
        type="text"
        id="name"
        variant="outlined"
        classes={{ root: classes.TextField }}
        onBlur={handleBlur}
        onChange={handleChange}
        value={name}
        helperText={touched.name && errors.name ? errors.name : ''}
        error={touched.name && errors.name ? true : false}
      />

      <TextField
        label="Correo electrónico*"
        type="email"
        id="email"
        variant="outlined"
        classes={{ root: classes.TextField }}
        onBlur={handleBlur}
        onChange={handleChange}
        value={email}
        helperText={touched.email && errors.email ? errors.email : ''}
        error={touched.email && errors.email ? true : false}
      />

      <TextField
        label="Teléfono de contacto*"
        type="text"
        id="phone"
        variant="outlined"
        classes={{ root: classes.TextField }}
        onBlur={handleBlur}
        onChange={handleChange}
        value={phone}
        helperText={touched.phone && errors.phone ? errors.phone : ''}
        error={touched.phone && errors.phone ? true : false}
      />
      <TextField
        label="Escríbenos tus comentarios*"
        type="text"
        id="commentary"
        variant="outlined"
        multiline={true}
        rows="4"
        //onChange={props.countChar}
        onChange={handleChange}
        inputProps={{
          maxLength: 300,
        }}
        style={{ height: 'auto' }}
        classes={{ root: classes.TextField }}
        onBlur={handleBlur}
        value={commentary}
        helperText={touched.commentary && errors.commentary ? errors.commentary : ''}
        error={touched.commentary && errors.commentary ? true : false}
      />

      <FormControlLabel
        classes={{
          root: classes.FormControlLabelRoot,
        }}
        control={
          <Checkbox
            name="termsAndConditions"
            id="termsAndConditions"
            checked={termsAndConditions}
            onChange={(event) => {
              handleChange(event);
              handleBlur(event);
            }}
            onBlur={handleBlur}
            value="checked"
            color="secondary"
            label="Términos y condiciones"
            classes={{
              root: classes.checkPadding,
            }}
          />
        }
        label={
          <>
            <p
              className={ classes.colorActiveLabel}
            >
              Acepto los
              <b> <a className={classes.labelTermino} href={ADDITIONAL_INFO} target='_blank' rel="noopener noreferrer">términos y condiciones</a></b>
            </p>
          </>
        }
      />

      <footer>
        <ButtonBase
          type="submit"
          onClick={handleSubmit}
          variant="primary"
          disabled={!isValid}
          className={classes.button}
          //style={{marginBottom: 48}}
        >
          Enviar mi opinión
        </ButtonBase>
      </footer>
    </div>
  );
};

export default AppOpinion;
